(function (Translator) {
    // de
    Translator.add("administration.user_search_button", "Suchen", "EvpAdministrationBundle", "de");
    Translator.add("administration.user_search_label", "Benutzer-ID", "EvpAdministrationBundle", "de");
    Translator.add("forbidden", "Nicht zugelassen", "EvpAdministrationBundle", "de");
    Translator.add("internal_server_error", "Serverfehler", "EvpAdministrationBundle", "de");
    Translator.add("invalid_code", "Falscher Code", "EvpAdministrationBundle", "de");
    Translator.add("invalid_grant", "Zugriff nicht gew\u00e4hrt", "EvpAdministrationBundle", "de");
    Translator.add("invalid_parameters", "Falsche Parameter", "EvpAdministrationBundle", "de");
    Translator.add("invalid_request", "Falsche Anfrage", "EvpAdministrationBundle", "de");
    Translator.add("invalid_state", "Falscher Status", "EvpAdministrationBundle", "de");
    Translator.add("limits_exceeded", "Das Limit ist erreicht", "EvpAdministrationBundle", "de");
    Translator.add("logout", "Abmelden", "EvpAdministrationBundle", "de");
    Translator.add("not_acceptable", "Nicht annehmbar", "EvpAdministrationBundle", "de");
    Translator.add("not_found", "Nicht gefunden", "EvpAdministrationBundle", "de");
    Translator.add("pagination.first", "Erste", "EvpAdministrationBundle", "de");
    Translator.add("pagination.last", "Letzte", "EvpAdministrationBundle", "de");
    Translator.add("pagination.next", "Weiter", "EvpAdministrationBundle", "de");
    Translator.add("pagination.page_out_of", "von", "EvpAdministrationBundle", "de");
    Translator.add("pagination.previous", "Zur\u00fcck", "EvpAdministrationBundle", "de");
    Translator.add("rate_limit_exceeded", "Das Limit ist erreicht", "EvpAdministrationBundle", "de");
    Translator.add("unauthorized", "Zugriff nicht gew\u00e4hrt", "EvpAdministrationBundle", "de");
})(Translator);
